import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import InfoModal from "./InfoModal";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ArrowCardToggle from "../../utils/components/ArrowCardToggle";
import {
  roundToDecimals,
  momentModule,
  getDaysOfWeek,
} from "../../utils/Utils";

import "../../../styles/components/utils/components/CostInfoModal.scss";
import info from "../../../styles/images/info.svg";

const { moment } = momentModule;

class CostInfoModal extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      readMore: false,
      cemeTariffs: null,
      infoModal: false,
    };
    this.getRestrictionTypes = this.getRestrictionTypes.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchCEMETariffs();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  getBrandName(planName) {
    switch (planName) {
      case "EVIO": {
        return "server_plan_EVIO_ad_hoc";
      }
      case "Salvador Caetano":
      case "KLC": {
        return "server_plan_EVIO_ad_hoc_goCharge";
      }
      case "Hyundai": {
        return "server_plan_EVIO_ad_hoc_hyundai";
      }
      default:
        return "server_plan_EVIO_ad_hoc";
    }
  }

  getRestrictionTypes(type, arr) {
    switch (type) {
      case "time":
      case "kwh":
      case "current":
      case "power": {
        return arr.values.map((item) =>
          item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_between" />{" "}
              {item.restrictionValues.start}
              {
                item.restrictionUom
              } <Translate value="infoTariffMobie_and" />{" "}
              {item.restrictionValues.end}
              {item.restrictionUom}
            </>
          ) : item.restrictionValues.start && !item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_after" />{" "}
              {item.restrictionValues.start}
              {item.restrictionUom}
            </>
          ) : !item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_before" />{" "}
              {item.restrictionValues.end}
              {item.restrictionUom}
            </>
          ) : (
            ""
          )
        );
      }
      case "date": {
        return arr.values.map((item) =>
          item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_between" />{" "}
              {moment(item.restrictionValues.start).format("DD-MM-YYYY")}{" "}
              <Translate value="infoTariffMobie_and" />{" "}
              {moment(item.restrictionValues.end).format("DD-MM-YYYY")}
            </>
          ) : item.restrictionValues.start && !item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_after" />{" "}
              {moment(item.restrictionValues.start).format("DD-MM-YYYY")}
            </>
          ) : !item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_before" />
              {moment(item.restrictionValues.end).format("DD-MM-YYYY")}
            </>
          ) : (
            ""
          )
        );
      }
      case "day": {
        return arr.values.map((item) =>
          item.restrictionValues.start
            ? getDaysOfWeek(item.restrictionValues.start)
            : ""
        );
      }
      case "duration": {
        return arr.values.map((item) =>
          item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_between" />{" "}
              {Math.floor(item.restrictionValues.start / 60)}min{" "}
              <Translate value="infoTariffMobie_and" />{" "}
              {Math.floor(item.restrictionValues.end / 60)}min
            </>
          ) : item.restrictionValues.start && !item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_after" />{" "}
              {Math.floor(item.restrictionValues.start / 60)}min
            </>
          ) : !item.restrictionValues.start && item.restrictionValues.end ? (
            <>
              <Translate value="infoTariffMobie_before" />{" "}
              {Math.floor(item.restrictionValues.end / 60)}min
            </>
          ) : (
            ""
          )
        );
      }
      default:
        return "";
    }
  }

  fetchCEMETariffs() {
    const planName = this.getBrandName(this.props.brand.brandName);

    axios
      .get("/api/private/cemeTariff", {
        params: {
          planName: planName,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            cemeTariffs: res.data,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  renderOtherNetworkInfo() {
    let str = I18n.t("mobieTariffPrice_energySuppliedInfo");
    const newStr = str.replace(
      "XXkWh",
      `${roundToDecimals(this.props.cost.consumption, 0)} kWh`
    );

    return (
      <div className="cost-info">
        <h2 className="title">
          <Translate value="mobieTariffPrice_title" />
        </h2>
        <div className="cost-section">
          <h4>
            <Translate value="mobieTariffPrice_chargingConsidered" />
          </h4>
          <div className="summary">
            <p>
              <Translate value="mobieTariffPrice_chargerAndPlug" />
            </p>
            <p>
              {this.props.charger.properties.name}(
              {this.props.selectedPlug.connectorType})
            </p>
          </div>
          <div className="summary">
            <p>
              <Translate value="mobieTariffPrice_startDate" />
            </p>
            <p>{moment(this.props.date).format("DD-MM-YYYY HH:DD:SS")}</p>
          </div>
          <div className="summary">
            <p>
              <Translate value="otherEVs_duration" />
            </p>
            <p>
              {this.props.estimateTime >= 60
                ? Math.trunc(this.props.estimateTime / 60) +
                  "h " +
                  (this.props.estimateTime % 60) +
                  "min"
                : this.props.estimateTime + "min"}
            </p>
          </div>
          <div className="summary">
            <p>
              <Translate value="sessions_energySupplied" />
            </p>
            <p>
              <button
                type="button"
                className="clear"
                onClick={() =>
                  this.setState({
                    infoModal: !this.state.infoModal,
                  })
                }
              >
                <img src={info} alt="" />
              </button>
              {roundToDecimals(this.props.cost.consumption, 0)} kWh
            </p>
          </div>
          {this.state.infoModal && <p className="info-power">{newStr}</p>}
        </div>
        <div className="cost-section">
          <div className="info">
            <p></p>
            <p>
              <b>
                <Translate value="mobieTariffPrice_unit" />
              </b>
            </p>
            <p>
              <b>
                <Translate value="mobieTariffPrice_qtd" />
              </b>
            </p>
            <p>
              <b>
                <Translate value="mobieTariffPrice_total" />
              </b>
            </p>
          </div>
          <div className="info-section">
            <div className="info">
              <p>
                <b>
                  <Translate value="mobieTariffPrice_energyAndNetworks" />
                </b>
              </p>
              <p>
                <b>
                  {this.props.cpoTariffsPrices?.detail?.emsp?.totalBykWh} €/kWh
                </b>
              </p>
              <p>-</p>
              <p>
                <b>{this.props.cpoTariffsPrices?.detail?.emsp?.total} €</b>
              </p>
            </div>
            <Accordion>
              {this.props.cpoTariffsPrices?.detail?.emsp?.entries.map(
                (item) => (
                  <>
                    {item.hasOwnProperty("collapsable") && (
                      <ArrowCardToggle eventKey={item.collapseGroup}>
                        <div className="info">
                          <p className="collapse-title">
                            <Translate
                              value={`session_simulator_${item.label}`}
                            />
                          </p>
                          <p>{item.unitPrice} €</p>
                          <p>
                            {item.unit === "s"
                              ? new Date(item.quantity * 1000)
                                  .toISOString()
                                  .slice(11, 19)
                              : item.unit === "UN"
                              ? `${item.quantity} sessão`
                              : `${item.quantity} kWh`}
                          </p>
                          <p>{item.total} €</p>
                        </div>
                      </ArrowCardToggle>
                    )}
                    {item.hasOwnProperty("group") && (
                      <Accordion.Collapse eventKey={item.group}>
                        <Card.Body>
                          <div className="info">
                            <p>
                              <Translate
                                value={`session_simulator_${item.label}`}
                              />
                            </p>
                            <p>{item.unitPrice} €</p>
                            <p>
                              {item.unit === "s"
                                ? new Date(item.quantity * 1000)
                                    .toISOString()
                                    .slice(11, 19)
                                : item.unit === "UN"
                                ? `${item.quantity} sessão`
                                : `${item.quantity} kWh`}
                            </p>
                            <p>{item.total} €</p>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    )}
                  </>
                )
              )}
            </Accordion>
          </div>
          <div className="info-section">
            <div className="info">
              <p>
                <b>
                  <Translate value="mobieTariffPrice_opcOperatorCharger" />
                </b>
              </p>
              <p>
                <b>
                  {this.props.cpoTariffsPrices?.detail?.cpo?.totalBykWh} €/kWh
                </b>
              </p>
              <p>-</p>
              <p>
                <b>{this.props.cpoTariffsPrices?.detail?.cpo?.total} €</b>
              </p>
            </div>
            {this.props.cpoTariffsPrices?.detail?.cpo?.entries.map((item) => (
              <div className="info">
                <div>
                  {item.title.map((label) => (
                    <p>
                      {label.restrictionType === "defaultFlat" ? (
                        <Translate value="infoTariffMobie_defaultRestrictionFlat" />
                      ) : label.restrictionType === "defaultTime" ? (
                        <Translate value="infoTariffMobie_defaultRestrictionTime" />
                      ) : label.restrictionType === "defaultEnergy" ? (
                        <Translate value="infoTariffMobie_defaultRestrictionEnergy" />
                      ) : label.restrictionType === "defaultParking" ? (
                        <Translate value="infoTariffMobie_defaultRestrictionParking" />
                      ) : (
                        this.getRestrictionTypes(label.restrictionType, label)
                      )}
                    </p>
                  ))}
                </div>
                <p>{item.unitPrice} €</p>
                <p>
                  {item.unit === "s"
                    ? new Date(item.quantity * 1000).toISOString().slice(11, 19)
                    : item.unit === "UN"
                    ? `${item.quantity} sessão`
                    : `${item.quantity} kWh`}
                </p>
                <p>{item.total} €</p>
              </div>
            ))}
          </div>
          <div className="info">
            <p>
              <b>
                IVA ({this.props.cpoTariffsPrices?.detail?.vat?.percentage}%)
              </b>
            </p>
            <p>
              <b>
                {this.props.cpoTariffsPrices?.detail?.vat?.totalBykWh} €/kWh
              </b>
            </p>
            <p>-</p>
            <p>
              <b>{this.props.cpoTariffsPrices?.detail?.vat?.total} €</b>
            </p>
          </div>
        </div>
        <div className="info">
          <p>
            <b>
              <Translate value="mobieTariffPrice_finalPrice" />
            </b>
          </p>
          <p>
            <b>
              {this.props.cpoTariffsPrices?.detail?.total?.totalBykWh} €/kWh
            </b>
          </p>
          <p>-</p>
          <p>
            <b>{this.props.cpoTariffsPrices?.detail?.total?.total} €</b>
          </p>
        </div>
      </div>
    );
  }

  renderTeslaInfo() {
    if (this.props.cost && this.props.cost.tariff)
      return (
        <div className="cost-info">
          <p>
            <Translate
              value="estimatedCost_infoTesla"
              superchargerCost={`0.34`}
            />
          </p>
          <p>
            <Translate
              value="estimatedCost_infoTesla2"
              costPerKWh={`${roundToDecimals(this.props.cost.tariff.value, 3)}`}
            />
          </p>
        </div>
      );
  }

  renderEVIOInfo() {
    if (
      this.props.cost &&
      this.props.cost.tariff &&
      this.props.cost.tariff.tariff
    )
      return (
        <>
          <div className="cost-info">
            <p>
              <Translate value="estimatedCost_info3_backoffice" />
            </p>
          </div>
          <div className="cost-components">
            <div className="cost-component">
              <Translate value="estimatedCost_booking" />
              <b>{` ${(this.props.cost.tariff.tariff.bookingAmount.value ?? "- ")}€`}</b>
            </div>
            <div className="cost-component">
              <Translate value="estimatedCost_activationFee" />
              <b>{` ${this.props.cost.tariff.tariff.activationFee}€`}</b>
            </div>
            <div className="cost-component">
              <Translate value="estimatedCost_charging" />
              <b>
                {` ${this.props.cost.tariff.tariff.chargingAmount.value}€/${this.props.cost.tariff.tariff.chargingAmount.uom}`}
              </b>
            </div>
            <div className="cost-component">
              <Translate value="estimatedCost_parkingDuringCharging" />
              <b>
                {` ${this.props.cost.tariff.tariff.parkingDuringChargingAmount.value}€/${this.props.cost.tariff.tariff.parkingDuringChargingAmount.uom}`}
              </b>
            </div>
            <div className="cost-component">
              <Translate value="estimatedCost_parking" />
              <b>
                {` ${this.props.cost.tariff.tariff.parkingAmount.value}€/${this.props.cost.tariff.tariff.parkingAmount.uom}`}
              </b>
            </div>
          </div>
          <div className="cost-table">
            <div className="table-container">
              <div className="table-header">
                <div className="row no-gutters">
                  <div className="col title">
                    <Translate value="estimatedCost_booking" />
                  </div>
                  <div className="col title">
                    <Translate value="estimatedCost_charging" />
                  </div>
                  <div className="col title">
                    <Translate value="estimatedCost_parking" />
                  </div>
                  <div className="col title">
                    <Translate value="estimatedCost_fees" />
                  </div>
                  <div className="col title total">
                    <Translate value="estimatedCost_total" />
                  </div>
                </div>
              </div>
              <div className="table-values">
                <div className="row no-gutters">
                  <div className="col title">{`${roundToDecimals(
                    this.props.cost.bookingCost,
                    3
                  )}€`}</div>
                  <div className="col title">{`${roundToDecimals(
                    this.props.cost.mainCost,
                    3
                  )}€`}</div>
                  <div className="col title">{`${roundToDecimals(
                    this.props.cost.parkingCompoundCost,
                    3
                  )}€`}</div>
                  <div className="col title">{`${roundToDecimals(
                    this.props.cost.feesCost,
                    3
                  )}€`}</div>
                  <div className="col title">{`${roundToDecimals(
                    this.props.cost.totalCost,
                    3
                  )}€`}</div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  renderCostInfo() {
    if (this.props.mode === "evio") return this.renderEVIOInfo();
    else if (this.props.mode === "tesla") return this.renderTeslaInfo();
    else return this.renderOtherNetworkInfo();
  }

  render() {
    if (this.props.cost)
      return (
        <InfoModal show={this.props.show} onHide={this.props.onHide} centered>
          <div id="costInfoModal">{this.renderCostInfo()}</div>
        </InfoModal>
      );
    else return null;
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(CostInfoModal);
